var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8011 13.3782H14.8258L12.7211 18.8096C12.4176 19.5929 13.2423 20.0008 13.7767 19.3728L20.2823 11.6239C20.4143 11.4685 20.4802 11.3131 20.4802 11.1448C20.4802 10.847 20.2427 10.6269 19.9194 10.6269H15.8947L17.9928 5.18905C18.2963 4.41221 17.4716 3.99789 16.9437 4.62584L10.4316 12.3748C10.2996 12.5366 10.2402 12.6855 10.2402 12.8539C10.2402 13.1581 10.4778 13.3782 10.8011 13.3782Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4528 5.60007H3.84C2.42615 5.60007 1.28 6.74622 1.28 8.16007V15.8401C1.28 17.2539 2.42615 18.4001 3.84 18.4001H11.5076C11.3593 18.8138 11.3361 19.2678 11.4555 19.6801H3.84C1.71923 19.6801 0 17.9608 0 15.8401V8.16007C0 6.03929 1.71923 4.32007 3.84 4.32007H15.5285L14.4528 5.60007Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2645 18.4001H25.6C27.0138 18.4001 28.16 17.2539 28.16 15.8401V8.16007C28.16 6.74622 27.0138 5.60007 25.6 5.60007H19.2054C19.355 5.18487 19.3773 4.73133 19.2577 4.32007H25.6C27.7208 4.32007 29.44 6.03929 29.44 8.16007V15.8401C29.44 17.9608 27.7208 19.6801 25.6 19.6801H15.1899L16.2645 18.4001Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7197 9.44019C31.4267 9.44019 31.9997 10.0133 31.9997 10.7202V13.2802C31.9997 13.9871 31.4267 14.5602 30.7197 14.5602V9.44019Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44488 11.5587L13.3767 6.88013H3.83957C3.13265 6.88013 2.55957 7.4532 2.55957 8.16013V15.8401C2.55957 16.5471 3.13265 17.1201 3.83957 17.1201H12.0024L12.9564 14.6583H10.8004C9.85588 14.6583 8.95957 13.9479 8.95957 12.854C8.95957 12.326 9.1663 11.9003 9.43887 11.5661L9.44488 11.5587Z",
    fill: "#07892B",
    fillOpacity: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7601 9.34703L18.712 6.88013H25.5998C26.3068 6.88013 26.8798 7.4532 26.8798 8.16013V15.8401C26.8798 16.5471 26.3068 17.1201 25.5998 17.1201H17.3389L21.2603 12.4493C21.535 12.1247 21.7598 11.6872 21.7598 11.1449C21.7598 10.0473 20.8526 9.34703 19.919 9.34703H17.7601Z",
    fill: "#07892B",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/charging.795942092e2d575cc1e53a1ca04375d5.svg";
export { ForwardRef as ReactComponent };